import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  fill() {
    const textarea = document.getElementById("message_content_input")
    if (textarea) {
      textarea.value = this.textValue
      textarea.focus()
      textarea.dispatchEvent(new Event("input"))
    }
  }
}
